import { Injectable } from "@angular/core";
import {
    CanActivate,
    Router,
    CanLoad,
    RouterStateSnapshot,
    ActivatedRouteSnapshot,
} from "@angular/router";
import { JwtHelperService } from "@auth0/angular-jwt";

import * as toastr from "toastr";
import { ObservableDataService } from "../../../services/core/observable-data.service";
import { AuthenticationService } from "../../../services/security/authentication.service";
import { StateService } from "../../../services/state/state.service";

@Injectable()
export class LoggedUserGuard implements CanActivate {
    constructor(
        private router: Router,
        private ods: ObservableDataService,
        private stateService: StateService,
        private jwt: JwtHelperService,
        private auth: AuthenticationService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        console.log("LoggedUserGuard.canActivate");

        const sessionInfo = this.ods.getLoggedUser();
        const isChangePasswordRoute = state.url === "/change-password";

        if (sessionInfo.isNewUser && !isChangePasswordRoute) {
            this.router.navigate(["/change-password"]);
            return false;
        }

        if (sessionInfo.token) {
            if (!this.jwt.isTokenExpired(sessionInfo.token)) {
                return true;
            } else {
                // Show the message.
                this.auth.logout();
                toastr.warning(
                    "Your user session has expired",
                    "Session Expired"
                );
            }
        }

        this.router.navigate(["/login"]);
        return false;
    }
}
